import React from 'react';
import ErrorBoundaryWidgetContainer from './ErrorBoundaryWidgetContainer';
import HoneycombTracer from '../../honeycomb/tracer';

const ComponentsToRender = {
  ActivityWidgetContainer: React.lazy(() => import('./ActivityWidgetContainer')),
  AppointmentWidgetContainer: React.lazy(() => import('./AppointmentWidgetContainer')),
  CalendarWidgetContainer: React.lazy(() => import('./CalendarWidgetContainer')),
  ClassWidgetContainer: React.lazy(() => import('./ClassWidgetContainer')),
  EventsListWidgetContainer: React.lazy(() => import('./EventsListWidgetContainer')),
  CourseWidgetContainer: React.lazy(() => import('./CourseWidgetContainer')),
  RentalWidgetContainer: React.lazy(() => import('./RentalWidgetContainer')),
  ReservationWidgetContainer: React.lazy(() => import('./ReservationWidgetContainer')),
  UpcomingEventWidgetContainer: React.lazy(() => import('./UpcomingEventWidgetContainer')),
  SearchWidgetContainer: React.lazy(() => import('./SearchWidgetContainer')),
};

export default class StorefrontWidgetContainer extends React.Component {
  constructor(props) {
    super(props);

    this.honeycombTracer = new HoneycombTracer();
  }

  componentDidMount() {
    const { widgetComponentName } = this.props;

    this.honeycombTracer.startActiveSpan('WidgetRendered', (span) => {
      span.setAttribute('widget.component', widgetComponentName);

      span.end();
    });
  }

  render() {
    const { widgetComponentName } = this.props;
    const ComponentToRender = ComponentsToRender[widgetComponentName];

    return (
      <ErrorBoundaryWidgetContainer widgetComponentName={widgetComponentName}>
        <React.Suspense fallback={null}>
          <ComponentToRender {...this.props} />
        </React.Suspense>
      </ErrorBoundaryWidgetContainer>
    );
  }
}
